import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
  useLocation
} from 'react-router-dom';

import Sidebar from './components/Sidebar';

//Admin
import UserList from './pages/Admin/UserList';
import AddUser from './pages/Admin/AddUser';
import AddUserMails from './pages/Admin/AddUserMails';
import UserMailList from './pages/Admin/UserMailList';
import CreateTags from './pages/Admin/CreateTags.js';
import TagList from './pages/Admin/TagList.js';

//User
import UserProfile from './pages/BU/UserProfile';

//Home
import LoginPage from './pages/Home/Login';
import Dashboard from './pages/Home/Dashboard';
import DashboardPage from './pages/Home/DashboardPage';

//Landing Page
import MailOpenLandingPage from './pages/LandingPages/MailOpenLandingPage';
import ButtonClickLandingPage from './pages/LandingPages/ButtonClickLandingPage';
import UnSubscribeLandingPage from './pages/LandingPages/UnSubscribeLandingPage';

//Mail
import MailOpenUserDetails from './pages/Mail/MailOpenUserDetails';
import UserLocationDetails from './pages/Mail/ButtonClickUserLocation';
import ViewMailDetails from './pages/Mail/ViewMailDetails';
import AddCampaign from './pages/Mail/AddCampaign';
import CampaignList from './pages/Mail/CampaignList';
import CreateTemplate from './pages/Mail/CreateTemplate';
import TemplateList from './pages/Mail/TemplateList.js';
import CreateContacts from './pages/Mail/CreateContacts';

//Mail Schedule 
import SendBulkMail from './pages/MailSchedule/SendBulkMail';
import CreateMailSchedule from './pages/MailSchedule/CreateMailSchedule';
import ScheduledMailDetails from './pages/MailSchedule/ScheduledMailDetails';

//Report
import AllDetailsList  from './pages/Reports/CampaignWiseReport/AllDetailsList.js';
import AudienceList  from './pages/Reports/CampaignWiseReport/AudienceList.js';
import AudienceDetailedList  from './pages/Reports/CampaignWiseReport/AudienceDetailedList.js';
import UnSubsribedList from './pages/Reports/UnSubscribedListReport/UnSubscribedList.js';

//Settings
import ChangePassword from './pages/Settings/ChangePassword';
import BounceListReport from './pages/Reports/BounceListReport.js';
import BounceMailUpdate from './pages/BU/BounceMailUpdatePage.js';




//import sampleImage from '.Images/test.jpg';
const PrivateRoute = () => {
  const isLoggedIn = sessionStorage.getItem("isLoggedIn") === "true";
  const location = useLocation();

  // If not logged in, redirect to login with intended destination
  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <Sidebar>
      <Outlet />
    </Sidebar>
  );
};

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  useEffect(() => {
    const loggedInStatus = sessionStorage.getItem("isLoggedIn") === "true";
    setIsLoggedIn(loggedInStatus);
  }, []);

  return (
    <Router>
      <Routes>
        {/* Public Route: Login Page */}
        <Route
          path="/login"
          element={<LoginPage setIsLoggedIn={setIsLoggedIn} />}
        />

        {/* Protected Routes with Sidebar Layout */}
        <Route element={<PrivateRoute />}>
          {/* Default route after login redirects to dashboard */}
          <Route index element={<Navigate to="/dashboard" />} />
          <Route path="/dashboard" element={<Dashboard />} />
          {/* <Route path="/DashboardPage" element={<DashboardPage />} /> */}

          {/** ADMIN */}
          <Route path="/UserList" element={<UserList />} />
          <Route path="/AddUser" element={<AddUser />} />
          <Route path="/AddUserMails" element={<AddUserMails />} />
          <Route path="/UserMailList" element={<UserMailList />} />
          <Route path="/CreateTags" element={<CreateTags />} />
          <Route path="/TagList" element={<TagList />} />

          {/** USER */}         
          <Route path="/UserProfile" element={<UserProfile />} />
          <Route path="/BounceMailUpdate" element={<BounceMailUpdate />} />
          <Route path="/ChangePassword" element={<ChangePassword />} />

          {/* Mail-related Routes */}

          <Route path="/SendBulkMail" element={<SendBulkMail />} />
          <Route path="/CreateMailSchedule" element={<CreateMailSchedule />} />
          <Route path="/ScheduledMailDetails" element={<ScheduledMailDetails />} />
          <Route path="/ViewMailDetails" element={<ViewMailDetails />} />
          <Route path="/UserLocationDetails" element={<UserLocationDetails />} />
          <Route path="/MailOpenUserDetails" element={<MailOpenUserDetails />} />
          <Route path="/AddCampaign" element={<AddCampaign />} />
          <Route path="/CampaignList" element={<CampaignList />} />
          <Route path="/CreateTemplate" element={<CreateTemplate />} />
          <Route path="/TemplateList" element={<TemplateList />} />
          <Route path="/CreateContacts" element={<CreateContacts />} />

          {/*Reports */}
          <Route path="/AllDetailsList" element={<AllDetailsList  />} />    
          <Route path="/AudienceList" element={<AudienceList />} />
          <Route path="/AudienceDetailedList" element={<AudienceDetailedList />} />
          <Route path="/UnSubsribedList" element={<UnSubsribedList />} />
          <Route path="/BounceListReport" element={<BounceListReport />} />


        </Route>

        {/* Routes redirect from mail */}
        <Route path="/MailOpenLandingPage" element={<MailOpenLandingPage />} />
        <Route path="/ButtonClickLandingPage" element={<ButtonClickLandingPage />} />
        <Route path="/UnSubscribeLandingPage" element={<UnSubscribeLandingPage />} />
       
       
        
        {/* Catch-all route */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
};

export default App;